<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(id)="data">
                <router-link class="text-data-link" :to="data.item.links.self"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.period"/>
            </template>

            <template v-slot:cell(rate)="data">
                <span v-text="data.item.data.attributes.rate"/>
            </template>

            <template v-slot:cell(total)="data">
                <span v-text="data.item.data.attributes.total"/>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestBillings",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'id', label: 'Code', tdClass: ''},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'date', label: 'Period', tdClass: 'text-muted'},
                        {key: 'rate', label: 'Rate', tdClass: 'text-muted text-right'},
                        {key: 'total', label: 'Total', tdClass: 'text-muted text-right'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
